import { render, staticRenderFns } from "./PublicRestroomTicket.vue?vue&type=template&id=064d029c&scoped=true&lang=pug&"
import script from "./PublicRestroomTicket.vue?vue&type=script&lang=js&"
export * from "./PublicRestroomTicket.vue?vue&type=script&lang=js&"
import style0 from "./PublicRestroomTicket.vue?vue&type=style&index=0&id=064d029c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d029c",
  null
  
)

export default component.exports